<template>
    <div class="divider">
        <div class="img"></div>
    </div>
</template>
<script>
export default {
    name: 'base-divider',
    props: {},
    created() {},
    data() {
        return {}
    },
    methods: {},
}
</script>
<style lang="scss" scoped>
.divider {
    width: 200%;
    height: 0.02rem;
    background: #c39b5e;
    left: 0;
    bottom: 0;
    transform: scale(0.5);
    transform-origin: left top;
    margin: 0.1rem 0;
    .img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.68rem;
        height: 0.38rem;
        background: url(~@/assets/img/divider.png) 0 0 no-repeat;
        background-size: cover;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseDivider.vue